import moment from 'moment'
import { RootState, Module, RegionFormat } from '../types'

import { GetProject } from '@/api/dashboard'

interface Server extends RegionFormat {
  UTCOffset: number
  timeStart: Date
  views: number
  tags: number
  devices: number
  alarms: number
  users: number
  datalogs: number
  uptime: string
}

export const server: Module<Server, RootState> = {
  namespaced: true,
  state() {
    return {
      shortDate: '',
      longDate: '',
      shortTime: '',
      longTime: '',
      shortDateTime: '',
      longDateTime: '',
      UTCOffset: 0,
      timeStart: new Date(1),
      views: 0,
      tags: 0,
      devices: 0,
      alarms: 0,
      users: 0,
      datalogs: 0,
      uptime: '',
    }
  },
  mutations: {},
  actions: {
    tick1s({ state }) {
      const utcOffset = state.UTCOffset / 60
      const mo = moment().utcOffset(utcOffset)
      state.shortDate = mo.format('DD-MM-YYYY')
      state.longDate = mo.format('DD MMMM YYYY')
      state.shortTime = mo.format('HH:mm')
      state.longTime = mo.format('HH:mm:ss')
      state.shortDateTime = mo.format('DD-MM-YYYY HH:mm:ss')
      state.longDateTime = mo.format('DD MMMM YYYY HH:mm:ss')

      const diff = moment().diff(moment(state.timeStart))

      const mod = diff % 86400000
      const msday = diff - mod
      const day = msday / 86400000
      const hours = moment.utc(mod).format('HH:mm:ss')
      state.uptime = `${day}d ${hours}`
    },

    async getProjectDashboard({ state }) {
      const project = await GetProject()

      state.UTCOffset = project.UTCOffset
      state.timeStart = project.timeStart
      state.tags = project.tags
      state.devices = project.devices
      state.views = project.views
      state.alarms = project.alarms
      state.users = project.users
      state.datalogs = project.datalogs
    },
  },
  getters: {},
}
